export default __webpack_public_path__ + "static/media/eu-hero-static.d67b6171.webp";